"use client";
import TextTestimonalCard from '@/components/landing/desktop/FirstTestimonials/TextTestimonalCard';
import { useGetAllTextTestimonals } from '@/lib/hooks/admin-dashboard/text-testimonal/get/useGetAllTextTestimonals';
import Link from 'next/link';
import React from 'react';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    type CarouselApi
} from "@/components/ui/carousel";
const TextTestimonal = ({ publicArea }: { publicArea?: boolean }) => {
    const { data, isLoading } = useGetAllTextTestimonals();
    const textTestimonals = data as TextTestimonal[];
    const [api, setApi] = React.useState<CarouselApi>();
    const [current, setCurrent] = React.useState(0);
    const [count, setCount] = React.useState(0);
    // Auto slide logic
    React.useEffect(() => {
        if (!api) return;

        setCount(api.scrollSnapList().length);
        setCurrent(api.selectedScrollSnap() + 1);

        api.on("select", () => {
            setCurrent(api.selectedScrollSnap() + 1);
        });

        const interval = setInterval(() => {
            const currentIndex = api.selectedScrollSnap();
            const lastIndex = api.scrollSnapList().length - 1;

            if (currentIndex === lastIndex) {
                api.scrollTo(0); // Go back to start
            } else {
                api.scrollNext(); // Go to next
            }
        }, 3000); // Change every 3 seconds

        return () => clearInterval(interval);
    }, [api]);
    if (isLoading) return <p>Loading...</p>;
    return (
        <main className='flex sm:p-10 flex-col gap-10'>
            {
                !publicArea && (
                    <header className='flex items-center justify-between'>
                        <h1 className='text-4xl'>Text Testimonals</h1>
                        <Link href={'/admin-dashboard/text-testimonal/create'} className='bg-skillsewa-primary text-zinc-50 px-4 py-2 rounded-lg'>Create</Link>
                    </header>
                )
            }
            <div className='hidden sm:flex flex-col sm:flex-row gap-10'>
                {textTestimonals.length > 0 ? textTestimonals.map((testimonal) => (
                    <TextTestimonalCard key={testimonal._id} testimonal={testimonal} />
                )) : <p>No Testimonals</p>}
            </div>
            <div className="w-[95vw] sm:hidden">
                <div className="mx-auto max-w-sm">
                    <Carousel setApi={setApi} className="w-full max-w-sm">
                        <CarouselContent>
                            {textTestimonals.length > 0 ? textTestimonals.map((testimonal) => (
                                <TextTestimonalCard key={testimonal._id} testimonal={testimonal} />
                            )) : <p>No Testimonals</p>}
                        </CarouselContent>
                    </Carousel>
                </div>
            </div>
        </main>
    );
}

export default TextTestimonal